import styled from "styled-components"

import {H3} from "@irati/ui/src/Typography"
import NoExistSvg from "@irati/ui/images/no_exist.svg"

export const Container = styled.div`
  background: url(${NoExistSvg}) no-repeat center;
  background-size: 50%;
  height: 165px;
  margin-bottom: 50px;
  padding: 0 30px 30px 30px;
  text-align: center;

  h3 {
    margin-bottom: 0 !important;
  }

  h4 {
    margin-top: 0 !important;
    margin-bottom: 20px !important;
  }
`

export const StyledH3 = styled(H3)`
  position: relative;
  &:after {
    content: "";
    display: block;
    position: absolute;
    width: 4%;
    bottom: -20px;
    left: 48%;
    border: 2px solid ${({theme}) => theme.colors.perkbox.blue};
    border-radius: 5px;
  }
`
